module.exports = __webpack_public_path__ + "static/media/countdownL.8b157310.jpg";